module.exports = __webpack_public_path__ + "static/img/PT.5061ac0d.jpg";